module.exports = __webpack_public_path__ + "static/media/lurker.e7db8f21.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsterImages/lurker.png
// module id = 127
// module chunks = 0